module.exports = __webpack_public_path__ + "static/media/c03-02-1.e3c92f66.png";